<div class="form-group">
  <h4>Please select company name, site name or corporate utility name.</h4>
  <ng-select
    [(ngModel)]="selectedLocation"
    (change)="setLocation()"
    [items]="locServ.locations$.value"
    bindLabel="LocationName"
    placeholder="Select a Location"
  ></ng-select>
</div>
